import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import {
  ChatBotSendMessageRequest,
  ChatBotSendMessageResponse,
  ChatBotSendFeedbackRequest,
  Prompt,
} from "./interfaces";
import { prompts } from "./prompts";

@Injectable({
  providedIn: "root",
})
export class ChatBotService {
  private url = `${environment.bimlApi}/supplier-chatbot-api`;

  constructor(private httpClient: HttpClient) {}

  sendMessage(
    request: ChatBotSendMessageRequest,
  ): Observable<ChatBotSendMessageResponse> {
    return this.httpClient.post<ChatBotSendMessageResponse>(
      `${this.url}/chat`,
      request,
    );
  }

  sendFeedback(request: ChatBotSendFeedbackRequest) {
    return this.httpClient.post(`${this.url}/feedback`, request);
  }

  getPrompts(): Observable<Prompt[]> {
    return of(prompts);
  }
}
